import React, { useState } from "react";
import { Outlet, useNavigate,useLocation } from "react-router-dom";
import Header from "./Header";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import PhoneAuth from "./PhoneAuth";
import { useTranslation } from "react-i18next";
import FooterVersion from "./FooterVersion";

export default function Layout({ user, login, logout }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location=useLocation();
  const [showAuth, setShowAuth] = useState(false);
  const getDefaultRouteByRole=(role)=>{
    if(role==="moderator") return "/moderator/dashboard";
    if(role==="admin" || role==="super_admin")return "/admin";
    return "/dashboard";
  };
  const showVersion = user && ["admin", "super_admin", "moderator"].includes(user.role);
  const handleAuthSuccess = (token, userData) => {
    login(token, userData);
    setShowAuth(false);
    //if user was trying to open protected page then redirect there afther login 
    const from =location.state?.from;
    const fromPath=from?.pathname?`${from.pathname}${from.search || ""}`:null;
    //otherwise go by role 
    const target =fromPath || getDefaultRouteByRole(userData?.role);
    navigate(target,{replace:true});
  };

  return (
    <>
      <Header
        user={user}
        logout={logout}
        onLoginClick={() => setShowAuth(true)}
      />
      <Outlet />
        <footer className="bg-gray-900 text-gray-300 py-10 px-6">
         <div className="max-w-7xl mx-auto text-center">
          <div className="flex items-center justify-center gap-2 mb-3">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center text-white font-bold">
              FM
            </div>
            <span className="text-xl font-bold text-white">FixOurIndia</span>
          </div>

          <p className="text-gray-400">{t("home.footer")}</p>
          {showVersion && ( 
          <div className="mt-2 flex justify-center">
           <FooterVersion />
          </div>
          )}
          <div className="mt-5 text-sm text-gray-500">
            © {new Date().getFullYear()} FixOurIndia. All rights reserved.
          </div>
         </div>
        </footer>

      <Dialog open={showAuth} onOpenChange={setShowAuth}>
        <DialogContent data-testid="auth-modal">
          <DialogHeader>
            <DialogTitle>{t("auth.loginWithPhone")}</DialogTitle>
          </DialogHeader>

          <PhoneAuth
            onSuccess={handleAuthSuccess}
            onCancel={() => setShowAuth(false)}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}